"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionList = exports.TransactionSummary = exports.TransactionListProvider = exports.transactionListSlice = void 0;
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const types_1 = require("types");
const ChainEventItem_1 = require("./ChainEventItem");
const ApiClient_1 = require("../clients/ApiClient");
const toolkit_1 = require("@reduxjs/toolkit");
const defaultSummary = {
    pendingCount: 0, total: 0,
};
async function txUpdater(eventItem, dispatch) {
    const ei = Object.assign({}, eventItem);
    delete ei.updater;
    const api = types_1.inject(ApiClient_1.ApiClient);
    const upE = await api.updateChainEvent(ei);
    if (upE) {
        dispatch(exports.transactionListSlice.actions.transactionUpdated(upE));
        return upE;
    }
    return eventItem;
}
const loadUserTransactions = toolkit_1.createAsyncThunk('', async (payload, ctx) => {
    const { application } = payload;
    try {
        const client = types_1.inject(ApiClient_1.ApiClient);
        console.log('PRE-PRE PRE LOADED TXS:');
        const txs = await client.getUserEvents(application);
        console.log('PRE-PRE LOADED TXS:', txs);
        if (txs) {
            txs.sort((t1, t2) => (t1.createdAt || t1.lastUpdate) > (t2.createdAt || t2.lastUpdate) ? 1 : -1);
            console.log('PRE LOADED TXS:', txs);
            ctx.dispatch(exports.transactionListSlice.actions.transactionsLoaded({ transactions: txs }));
        }
    }
    catch (e) {
        console.error('Error loading user transactions', { application, error: e });
    }
});
exports.transactionListSlice = toolkit_1.createSlice({
    name: 'transactionListSlice',
    initialState: [],
    reducers: {
        transactionsLoaded: (state, action) => {
            console.log('LOADED TXS:', action.payload);
            action.payload.transactions.forEach((t) => state.push(t));
        },
        transactionUpdated: (state, action) => {
            const tx = action.payload;
            const idx = state.findIndex(t => t.id === tx.id);
            if (idx >= 0) {
                state[idx] = tx;
            }
        },
        addTransaction: (state, action) => {
            const tx = action.payload;
            state.unshift(tx);
        }
    }
});
function TransactionListProvider(props) {
    const dispatch = react_redux_1.useDispatch();
    const userId = react_redux_1.useSelector((state) => { var _a, _b, _c; return (_c = (_b = (_a = state === null || state === void 0 ? void 0 : state.connection) === null || _a === void 0 ? void 0 : _a.account) === null || _b === void 0 ? void 0 : _b.user) === null || _c === void 0 ? void 0 : _c.userId; });
    const { application } = props;
    react_1.useEffect(() => {
        if (userId) {
            dispatch(loadUserTransactions({ application }));
        }
    }, [userId, application]);
    return (react_1.default.createElement(react_1.default.Fragment, null));
}
exports.TransactionListProvider = TransactionListProvider;
function TransactionSummary(props) {
    const allEvents = react_redux_1.useSelector((state) => { var _a; return (_a = state === null || state === void 0 ? void 0 : state.data) === null || _a === void 0 ? void 0 : _a.transactions; }) || [];
    const events = allEvents.filter(e => e.network === props.network && props.eventIsRelevant(e));
    const pendingCount = events.filter(e => e.status === 'pending').length;
    console.log('All events vs relevant', allEvents.length, events.length, props.network);
    if (!props.network) {
        console.log('NO NETWORK!');
        return (react_1.default.createElement(props.summaryView, { summary: defaultSummary }));
    }
    const summary = {
        pendingCount,
        total: events.length,
    };
    console.log('SUMMARY', summary);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(props.summaryView, { summary: summary })));
}
exports.TransactionSummary = TransactionSummary;
function TransactionList(props) {
    const events = react_redux_1.useSelector((state) => { var _a; return (_a = state === null || state === void 0 ? void 0 : state.data) === null || _a === void 0 ? void 0 : _a.transactions; }) || [];
    return (react_1.default.createElement(react_1.default.Fragment, null, events.filter(e => props.eventIsRelevant(e)).map((e, i) => (react_1.default.createElement(ChainEventItem_1.ChainEventItem, { network: e.network, id: e.id, initialStatus: e.status, eventType: e.eventType, event: e, updater: txUpdater },
        react_1.default.createElement(props.eventView, { event: e, key: i }))))));
}
exports.TransactionList = TransactionList;
//# sourceMappingURL=TransactionList.js.map